module.exports = __webpack_public_path__ + "static/media/starDestroyer.639f0c27.png";